import { render, staticRenderFns } from "./GroupCategory.vue?vue&type=template&id=6e08dd30&scoped=true"
import script from "./GroupCategory.vue?vue&type=script&lang=js"
export * from "./GroupCategory.vue?vue&type=script&lang=js"
import style0 from "./GroupCategory.vue?vue&type=style&index=0&id=6e08dd30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08dd30",
  null
  
)

export default component.exports